import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GetSingleSchool from "../../../../Controllers/Admin/Schools/GetSingleSchool";
import CreateClass from "../../../../Controllers/Admin/ClassAndCourses/CreateClass";
import UpdateClass from "../../../../Controllers/Admin/ClassAndCourses/UpdateClass";
import GetSingleClass from "../../../../Controllers/Admin/ClassAndCourses/GetSingleClass";

export default function AddClassViewModel() {
  const [LocalStorageItems, setLocalStorageItems] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));

    if (items) {
      setLocalStorageItems(items);
    }
  }, []);

  const navigate = useNavigate();
  let location = useLocation();

  const [AuthUser, setAuthUser] = useState();

  const [ClassNameError, setClassNameError] = useState(false);
  const [ClassCodeError, setClassCodeError] = useState(false);
  const [ClassSessionError, setClassSessionError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [ClassID, setClassID] = useState("");

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddClass, setAddClass] = useState({
    ClassName: "",
    ClassCode: "",
    Session: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");

    if (LocationArray[4] === "update") {
      // setIsCheckError(true);
      setIsUpdate(true);
      setClassID(LocationArray[5]);
      const fetchData = async () => {
        const ClassData = await GetSingleClass(ClassID);
        setAddClass({
          ClassName: ClassData?.ClassName,
          ClassCode: ClassData?.ClassCode,
          Session: ClassData?.Session,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, ClassID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddClass.ClassName === "" ||
      AddClass.ClassName === null ||
      AddClass.ClassName === undefined ||
      AddClass.ClassName.length < 3
    ) {
      setClassNameError(true);
      flag++;
    } else {
      setClassNameError(false);
    }
    if (
      AddClass.ClassCode === "" ||
      AddClass.ClassCode === null ||
      AddClass.ClassCode === undefined ||
      AddClass.ClassCode.length < 3
    ) {
      setClassCodeError(true);
      flag++;
    } else {
      setClassCodeError(false);
    }

    if (
      AddClass.Session === "" ||
      AddClass.Session === null ||
      AddClass.Session === undefined ||
      AddClass.Session < 1
    ) {
      setClassSessionError(true);
      flag++;
    } else {
      setClassSessionError(false);
    }

    return flag;
  }, [AddClass.ClassName, AddClass.ClassCode, AddClass.Session]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterClass = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const ClassFinalObject = {
          ...AddClass,
        };

        await UpdateClass(ClassFinalObject, ClassID)
          .then(() => {
            navigate("/user/admin/classes");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const ClassFinalObject = {
          ...AddClass,
        };
        await CreateClass(ClassFinalObject, AuthUser.uid, LocalStorageItems)
          .then(() => {
            navigate("/user/admin/classes");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterClass,
    FormDisabled,
    AddClass,
    setAddClass,
    ClassNameError,
    ClassCodeError,
    ClassSessionError,
    IsUpdate,
  };
}
